import getMetricsData from '@api/metricContainer';
import { get } from 'lodash';
import instance from '@api/axiosInstance';
import { formatTimeseriesData } from '@src/components/metrics-panel-hz/utils/format';
import { createQuery } from '../../utils/query';
import useQueryParams from '../../hooks/useQueryParams';
import useWidgetQuery from '../../hooks/useWidgetQuery';

function useFetchQoEData({
  wid,
  metrics = [],
  currentKpi,
}: {
  wid: string;
  metrics: string[];
  currentKpi: any;
}) {
  const { interval, filter, _rKey, liveMode } = useQueryParams();
  const allowedMetricList = [...new Set([...metrics])];

  // TODO: filter metrics

  const options = currentKpi ? { kpiConfig: currentKpi } : {};

  const payload = createQuery(
    allowedMetricList,
    `${interval.from}/${interval.to}`,
    interval?.granularity,
    filter,
    options,
  );

  return useWidgetQuery({
    wid,
    queryKey: ['widget', 'qoe', payload.queries, _rKey, currentKpi],
    queryFn: () =>
      getMetricsData(payload, {}, instance).then((response) => {
        const { totals, data, annotations } = get(response, ['data', '0'], {
          totals: {},
          data: [],
          annotations: [],
        });
        const formattedData = formatTimeseriesData({
          metrics: allowedMetricList,
          data,
          interval,
          annotations,
        });
        return { data: formattedData, totals };
      }),
    options: {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!metrics.length && !liveMode,
      staleTime: 5 * 60 * 1000, // 5m
    },
  });
}

export default useFetchQoEData;
